import { ReactComponent as IconDataElement } from "@/assets/svgs/data-element-grey.svg";
import { ReactComponent as IconDocument } from "@/assets/svgs/document-grey.svg";
import { ReactComponent as IconPin } from "@/assets/svgs/icon-eclip-package-card.svg";
import { ReactComponent as IconMenu } from "@/assets/svgs/menu-dark.svg";
import MenuDropDown from "@/components/MenuDropDown";
import { ToastContext } from "@/context/toast/index.js";
import useModal from "@/hooks/use-modal/index.js";
import useStaticData from "@/hooks/use-static-data/index";
import { useLocation, useNavigate } from "@/lib/router-dom";
import api from "@/services/api/eclips.js";
import moment from "moment";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import MultiClamp from 'react-multi-clamp';
import { useSelector } from 'react-redux';
import ConfirmDeclineModal from "./confirm-decline-modal.jsx";
import MoveFolderModal from "./move-folder-modal.jsx";
import PinToTop from "./pin-to-top.jsx";

export default function EclipCard({ item }) {
	const { goTo } = useNavigate();
	const { t } = useTranslation();
	const { currentPath } = useLocation();
	const { addToastMessage } = useContext(ToastContext);
	const isShared = currentPath.includes("shared");
	const user = useSelector(state => state.auth.user)

	const {
		visible: isShowMoveEcliptoFolderModal,
		show: showEcliptoFolderFolderModal,
		hide: hideEcliptoFolderModel,
	} = useModal();

	const {
		visible: isConfirmDeclineModalVisible,
		show: showConfirmDeclineModal,
		hide: hideConfirmDeclineModal,
	} = useModal();

	const staticData = useStaticData();

	const onDeclineConfirm = async (message) => {
		await api.declineRequest(item.id, { message });
		hideConfirmDeclineModal();
		document.getElementById("reload-eclips")?.click();
		addToastMessage("Declined package successfully", "success");
	};

	const handleClick = (e) => {
		if (e.isPropagationStopped()) {
			return;
		}

		if (item?.badge === "PACKAGE_DECLINED" && item?.request) {
			addToastMessage("Package Declined", "error");
			return;
		}
		if (item?.badge === "PACKAGE_ACCEPTED") {
			if (isShared) {
				addToastMessage("No data available yet", "error");
				return;
			}
		}
		if (item?.badge === "PACKAGE_REQUESTED") {
			if (isShared) {
				addToastMessage("Receipient has not responded yet", "error");
				return;
			}
			goTo(`/eclip/respond/${item.id}`);
			return;
		}

		goTo(`/eclip/send/${item.id}`);
	};

	const GetMeta = () => {
		let text;
		if(item.type ==="SEND"){
			return <></>
		}

		if(item?.receivingType === "COPY" && item?.consumedOrgId) {
			text = "Consumed by " + staticData.orgs.find((org)=> org.orgId === item.consumedOrgId).name
		}

		if(item?.onBehalfOf?.length > 1){
			text = "On behalf of multiple contributors"
		}

		if(item?.onBehalfOf?.length === 1 && item?.onBehalfOf[0]?.id !== item?.recipientOrgId && item?.onBehalfOf[0]?.name){
			text = "On behalf of " + item?.onBehalfOf[0]?.name
		}

		if(text) {
			return (
				<div className="eclip-card__content__org-name">
					<span>{text}</span>
				</div>
			)
		}

		return <></>
	}

	return (
		<>
			<ConfirmDeclineModal
				isVisible={isConfirmDeclineModalVisible}
				cancel={hideConfirmDeclineModal}
				confirm={onDeclineConfirm}
				title={"Decline Package"}
				packageName={item?.name}
			/>
			<div
				id="card"
				className="eclip-landing_eclip-card"
				onClick={handleClick}
				draggable
				onDragStart={(ev) => {
					ev.target.style.cursor = "copy";
					ev.dataTransfer.dropEffect = "copy";
					ev.dataTransfer.setData("text/plain", item.id);
				}}
			>
				<div className="eclip-landing__flex">
					<div
						className={`eclip-landing-eclip-box ${
							item?.eclipFolderId ? "folder" : ""
						}`}
					>
						{/* {item?.eclipFolderId ? <IconFolder /> : <IconPin />} */}
						<IconPin />
					</div>

					<div className="eclip-landing_cursor-mode__pointer icon-group">
						<PinToTop eclipId={item.id} pinned={item.pinned} />
						<MenuDropDown
							button={(props) => (
								<span
									className="eclip-landing_cursor-mode__pointer cursor-lg-area"
									{...props}
								>
									<IconMenu />
								</span>
							)}
							list={[
								{
									label: "Move",
									onClick: (e) => {
										e.stopPropagation();
										showEcliptoFolderFolderModal();
									},
								},
								isShared && item.badge !== "PACKAGE_DECLINED" && !item.request
									? {
											label: "Decline",
											onClick: (e) => {
												e.stopPropagation();
												showConfirmDeclineModal();
											},
									  }
									: undefined,
							]}
						/>
					</div>
				</div>
				<div className="eclips-landing_folder--label eclips-landing_eclip--label eclip-landing_cursor-mode__pointer trim--three-lines">
					{item.name}
				</div>
				<div
					className="eclip-landing-recipient-label trim"
					style={{ color: "#A614B9" }}
				>
					<MultiClamp clamp={1}>
						{item.recipients?.[0]?.name || (
							<span className="no-reciepint">
								No recipient selected
							</span>
						)}
					</MultiClamp>
				</div>
				<div className="eclip-card__content__set-height">
					<GetMeta/>
					<div className="eclip-card-date">
						{moment(item.modified).format("llll")}
					</div>
				</div>
				<div className="eclip-card__summary">
					<div>
						<IconDataElement />
						<span>
							{String(item?.dataElementsCount).padStart(2, "0")}
						</span>
					</div>
					<div>
						<IconDocument />
						<span>
							{String(item?.attachmentsCount).padStart(2, "0")}
						</span>
					</div>
					{item.receivingType === "COPY" && (
						<div className="eclip-landing-data-table__copy-lable tooltip">
							<span className="tooltiptext tooltiptext__copy-label">
								Copy of the data shared by your data provider
							</span>
							COPY
						</div>
					)}
				</div>
				{item?.badge ? (
					<div className={`eclip-card__progress ${item?.badge}`}>
						<div className="eclip-card__progress__text">
							{t(item?.badge)}
						</div>
					</div>
				) : (
					<div className={`eclip-card__progress`}>
						<progress
							className="eclip-card__progress__bar"
							value={item?.completionPercentage}
							max="100"
						></progress>
						<div className="eclip-card__progress__percentage">
							{item?.completionPercentage}%
						</div>
					</div>
				)}
			</div>

			<MoveFolderModal
				visible={isShowMoveEcliptoFolderModal}
				close={hideEcliptoFolderModel}
				id={item.id}
				eclipFolderId={item?.eclipFolderId}
			/>
		</>
	);
}
